<div class="link-component">
  <dx-text-box valueChangeEvent="keyup" [disabled]="disabled()" [readOnly]="readonly()" [isValid]="isValid" [value]="value()" (onValueChanged)="onValueChanged($event)" (onBlur)="onBlur()">
    <dxi-button name="picker" [options]="pickerButton" />
  </dx-text-box>
</div>
